import React from 'react';
import type { ReactNode } from 'react';

interface ContainerProps {
    children: ReactNode;
    className?: string;
    fullWidth?: boolean;
    style?: React.CSSProperties;
}
const Container: React.FC<ContainerProps> = ({ children, className, fullWidth, style }) => {
    return (
        <div
            className={`
                w-full
                ${fullWidth ? 'max-w-none' : ''}
                mx-auto
                px-4 py-6
                sm:px-6 sm:py-8
                md:px-10 md:py-10
                lg:px-20 lg:py-12
                ${className ?? ''}
            `}
            style={{ ...(fullWidth ? { width: '85vw' } : {}), ...(style ?? {}) }}
        >
            {children}
        </div>
    );
};

export default Container;
